// Chat store — export-to-JSON action: fetches the pages not loaded yet, builds
// a download, releases the object URL. No cross-store mutations.
import { loadWholeConversation } from './chatStore.conversation.js';
import { addError } from './chatStore.mutations.js';
import type { ChatMessage, ChatState, StreamSegment } from './chatStore.types.js';

export async function exportCurrentConversation(s: ChatState): Promise<void> {
  if (s.messages.length === 0) return;
  let all: ChatMessage[];
  try {
    all = await loadWholeConversation();
  } catch (e) {
    addError(
      `Export failed — could not load the whole conversation: ${e instanceof Error ? e.message : 'network error'}`,
    );
    return;
  }

  const exportData = all
    .filter((m) => m.role !== 'error')
    .map((msg) => {
      if (msg.role === 'system') return { role: 'system' as const, content: msg.content ?? '' };
      if (msg.role === 'user') return { role: 'user' as const, content: msg.content ?? '' };
      const text = (msg.segments ?? [])
        .filter((seg): seg is Extract<StreamSegment, { type: 'text' }> => seg.type === 'text')
        .map((seg) => seg.content)
        .join('');
      return { role: 'assistant' as const, content: text };
    });

  const json = JSON.stringify(
    {
      conversationId: s.conversationId,
      exportedAt: new Date().toISOString(),
      messages: exportData,
    },
    null,
    2,
  );
  const blob = new Blob([json], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `conversation-${s.conversationId.slice(0, 8)}-${new Date().toISOString().slice(0, 10)}.json`;
  a.click();
  URL.revokeObjectURL(url);
}
